import { Text } from '@applyboard/crystal-ui';
import { useTranslation } from '@applyboard/ui-utils';

const MandatoryFieldsHelpText = () => {
  const { t } = useTranslation();
  return (
    <Text intent="secondary" contrast="low">
      {t('loans.mandatoryText-1')}
      <span style={{ color: '#C01C48' }}> * </span>
      {t('loans.mandatoryText-2')}
    </Text>
  );
};

export default MandatoryFieldsHelpText;
